// extracted by mini-css-extract-plugin
export default {"form":"EditChannelPopup_form__v4DXd","error":"EditChannelPopup_error__6WZin"};